import request from '@/utils/request'

export const downloadApi = {
  get(params) {
    return request({
      url: '/agency/sys/report_dog_task/',
      method: 'get',
      params
    })
  },
  download(id) {
    return request({
      url: `/agency/sys/report_dog_task/${id}/`,
      method: 'get',
    })
  },
}
